import _ from "lodash"
import {
  WIDGET_MAPPED_COACH_STATUSES,
  SPECIALTY_IMAGES,
  SPECIALIZATION_GROUP_DISPLAY_MODES,
} from "@/store/coaching/widget/widget.constants"
import { GAME_KEYS } from "@/store/game/game.constants"
import { fetchCoaches } from "@/store/coaching/coaching.apis"

export const mapStatus = (status, statusState) => {
  if (status === "online") {
    switch (statusState) {
      case "idle":
      case "available":
        return WIDGET_MAPPED_COACH_STATUSES.ONLINE
      case "busy":
        return WIDGET_MAPPED_COACH_STATUSES.BUSY
      case "in-session":
        return WIDGET_MAPPED_COACH_STATUSES.IN_SESSION
      default:
        return WIDGET_MAPPED_COACH_STATUSES.OFFLINE
    }
  }
  return WIDGET_MAPPED_COACH_STATUSES.OFFLINE
}

export const getSpecialtyImage = (game, specialty) => {
  return _.get(SPECIALTY_IMAGES, [game, specialty], null)
}

export const getSpecializationGroupDisplayMode = gameKey => {
  switch (gameKey) {
    case GAME_KEYS.SSBU:
      return SPECIALIZATION_GROUP_DISPLAY_MODES.BY_FOCUS
    default:
      return SPECIALIZATION_GROUP_DISPLAY_MODES.BY_CATEGORY
  }
}

export const getCoachList = async (filters, pageNumber) => {
  const coachList = []
  let page = pageNumber || 1
  let shouldContinueLoop = null

  do {
    const coachData = await fetchCoaches({
      filters,
      page: page++,
    })
    const coaches = coachData?.result?.data || []
    coachList.push(...coaches)
    // if pageNumber is provided end loop immediately
    shouldContinueLoop = pageNumber ? null : !!coachData?.result?.next_page_url || null
  } while (shouldContinueLoop !== null)

  return coachList
}



// WEBPACK FOOTER //
// ./src/store/coaching/widget/widget.utils.js